<header class="header d-flex align-items-center justify-content-between">
    <div class="left d-flex align-items-center">
        <button class="mobile-menu-btn d-lg-none" (click)="toggleMobileSidebar()">
            <i class="fas fa-bars"></i>
        </button>
        <img src="../../../../../assets/img/monkey.png" [routerLink]="['beekids/accueil']" alt="Logo" class="logo">
        <h1>
            <span class="blue" [routerLink]="['beekids/accueil']">BEE</span>
            <span class="orange" [routerLink]="['beekids/accueil']">-KIDS</span>
        </h1>
    </div>

    <div class="center d-flex flex-column align-items-center">
        <div class="d-flex align-items-center">
            <img [src]="logoUrl || 'assets/img/monkey.png'" (error)="handleImageError($event)" alt="Logo Établissement"
                class="maternelle-logo" style="cursor: pointer;" />
            <h1>
                <span class="blue" [routerLink]="['/beekids/accueil']">{{ nom }}</span>
            </h1>
        </div>
        <small *ngIf="logoErrorDetails" style="color: red; font-size: 10px; margin-top: 5px;">{{ logoErrorDetails }}</small>
    </div>


    <div class="right d-flex align-items-center">
        <!-- Language Switcher - Modern Design -->
        <div class="language-switcher-header me-3">
            <select class="language-select-header" (change)="switchLang($any($event.target).value)" [value]="translate.currentLang">
                <option value="fr">🇫🇷 Français</option>
                <option value="en">🇬🇧 English</option>
                <option value="ar">🇹🇳 العربية</option>
            </select>
            <i class="fas fa-globe language-icon-header"></i>
        </div>

        <!-- Notification -->
        <div class="notification-container position-relative me-3">
            <i class="fas fa-bell icon" (click)="toggleNotificationDropdown()"></i>
            <span class="badge" *ngIf="newNotificationCount > 0">{{ newNotificationCount }}</span>

            <div class="notification-dropdown" [ngClass]="{ 'show': notificationDropdownVisible }">
                <div class="notification-header d-flex justify-content-between align-items-center">
                    <h5>{{ 'HEADER.NOTIFICATIONS' | translate }}</h5>
                    <div>
                        <button class="btn-mark-read" (click)="markAllNotificationsAsRead()" *ngIf="newNotificationCount > 0">
                            <i class="fas fa-check-double me-1"></i>Tout marquer lu
                        </button>
                        <button class="close-btn" (click)="toggleNotificationDropdown()">&times;</button>
                    </div>
                </div>

                <div class="notification-list">
                    <!-- Si la liste est vide -->
                    <div *ngIf="userNotifications.length === 0" class="no-notification-message">
                        <i class="fas fa-bell-slash empty-icon"></i>
                        <p>{{ 'HEADER.NO_NOTIFICATIONS' | translate }}</p>
                    </div>



                    <!-- Si la liste contient des notifications -->
                    <div
                         [ngClass]="{
                           'notification-item': true,
                           'unread': !userNotification.read,
                           'notif-danger':  userNotification.type === 'DEMANDE_REFUSED' || userNotification.type === 'CONGE_REFUSED' || userNotification.type === 'CONTRAT_EXPIRE',
                           'notif-success': userNotification.type === 'DEMANDE_ACCEPTED' || userNotification.type === 'CONGE_ACCEPTED' || userNotification.type === 'CONTRAT_CREATED',
                           'notif-warning': userNotification.type === 'PRESENCE_ABSENT',
                           'notif-info':    userNotification.type === 'DEMANDE_CREATED' || userNotification.type === 'CONGE_CREATED' || userNotification.type === 'CONTRAT_SIGNE',
                           'notif-default': !userNotification.type
                         }"
                         *ngFor="let userNotification of userNotifications"
                         (click)="navigateToNotifications(userNotification.type, userNotification)">

                        <!-- Icône du type -->
                        <div class="notif-type-icon">
                            {{ getNotificationIcon(userNotification.type) }}
                        </div>

                        <!-- Photo ou avatar par défaut -->
                        <img *ngIf="userNotification.photoUrl"
                             [src]="userNotification.photoUrl"
                             class="user-avatar" alt="avatar" />
                        <img *ngIf="!userNotification.photoUrl"
                             src="../../../../../assets/img/Admin.png"
                             class="user-avatar" alt="avatar" />

                        <!-- Contenu -->
                        <div class="notification-content">
                            <p [class.fw-bold]="!userNotification.read">
                                {{ userNotification.content }}
                            </p>
                            <small>{{ userNotification.createdAt | date: 'dd/MM/yyyy, HH:mm' }}</small>
                        </div>

                        <!-- Point "non lu" -->
                        <span class="unread-dot" *ngIf="!userNotification.read"></span>

                        <!-- Bouton "Marquer non lu" -->
                        <button class="btn-mark-unread" *ngIf="userNotification.read"
                                (click)="markAsUnread($event, userNotification)"
                                title="Marquer non lu">
                            <i class="fas fa-envelope"></i>
                        </button>
                    </div>
                </div>
            </div>
        </div>



        <!-- Message -->
        <span class="notification-icon me-3">
            <i class="fas fa-envelope icon" (click)="navigateToMessages()"></i>
            <span class="badge" *ngIf="newMessageCount > 0">{{ newMessageCount }}</span>
        </span>

        <!-- Profil -->
        <div class="profile-container position-relative me-3">
            <img [src]="profileImageUrl" alt="Profile Icon" class="profile-icon" (click)="toggleDropdown()">
            <div class="dropdown-content" [ngClass]="{'show': dropdownVisible}">
                <a [routerLink]="['/beekids/profil']" class="dropdown-item">
                    <i class="fas fa-user-circle"></i> {{ 'HEADER.VIEW_PROFILE' | translate }}
                </a>
                <a href="#" class="dropdown-item" (click)="handleLogout()">
                    <i class="fas fa-sign-out-alt"></i> {{ 'HEADER.LOGOUT' | translate }}
                </a>
            </div>
        </div>


        <!-- MODAL DE SUIVI -->
        <div class="modal fade" id="suiviModal2" tabindex="-1" aria-hidden="true">
            <div class="modal-dialog modal-lg">
                <div class="modal-content">
                    <div class="modal-header flex-column align-items-center text-center ">
                        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                        <div class="modal-header flex-column align-items-center text-center">
                            <h5 class="modal-title mb-3" id="suiviModalLabel">{{content }}</h5>
                            <img [src]="childImage === '/images/default-photo.jpg' ? 'assets/img/Admin.png' : childImage"
                                class="child-photo rounded-circle" alt="Élève" style="
                                    width: 100px;
                                    height: 100px;
                                    object-fit: cover;
                                    border: 3px solid #007bff;
                                    box-shadow: 0 0 10px rgba(0, 0, 0, 0.15);
                                ">
                        </div>
                    </div>

                    <br>

                    <div class="modal-body">
                        <br>
                        <div class="modal-body" style="margin-top: -50px;">

                            <!-- Tableaux des icônes -->
                            <div class="row g-3">
                                <div *ngFor="let suivi of suivis" class="col-md-6">
                                    <h6>{{ 'SUIVI.' + suivi.title.toUpperCase() | translate }}</h6>
                                    <label *ngFor="let emoji of suivi.options" class="emoji-label">
                                        {{ emoji.icon }}
                                        <input type="checkbox" [(ngModel)]="emoji.checked" class="form-check-input"
                                            [disabled]="true" />
                                    </label>
                                </div>
                            </div>

                            <!-- Commentaires -->
                            <div class="comment-section mt-3">
                                <label class="fw-bold">{{ 'SUIVI.COMMENTS_LABEL' | translate }}</label>
                                <label class="form-control" rows="3">{{commentaire}}</label>
                            </div>
                        </div>
                        <div class="modal-footer">
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- POPUP DÉTAILS ÉVÉNEMENT -->
        <div class="custom-modal-backdrop" *ngIf="isPopupVisible" (click)="closePopup()">
            <div class="custom-modal-content" (click)="$event.stopPropagation()">
                <button class="modal-close-button" (click)="closePopup()">&times;</button>

                <h2 class="modal-title">🗓️ {{ 'HEADER.EVENT_DETAILS' | translate }}</h2>

                <div class="modal-body">
                    <div class="event-image-wrapper" *ngIf="selectedEvent?.photoUrl">
                        <img [src]="selectedEvent?.photoUrl" [alt]="selectedEvent?.titre" />
                    </div>


                    <div class="event-info">
                        <p><strong>{{ 'HEADER.EVENT_TITLE' | translate }}</strong> {{ selectedEvent?.titre }}</p>
                        <p><strong>{{ 'HEADER.EVENT_DESCRIPTION' | translate }}</strong> {{ selectedEvent?.description }}</p>
                        <p><strong>{{ 'HEADER.EVENT_DATE' | translate }}</strong> {{ selectedFullDate }}</p>
                    </div>

                    <div class="user-info-wrapper" *ngIf="selectedEvent?.userId">
                        <div class="user-details">
                            <p class="event-details">
                                <strong>{{ 'HEADER.EVENT_CREATED_BY' | translate }}</strong>
                            </p>
                            <img *ngIf="selectedEvent?.userPhotoUrl" [src]="selectedEvent?.userPhotoUrl"
                                [alt]="'Photo de ' + selectedEvent?.userNom" class="user-avatar" />
                            <p class="event-details">
                                {{ selectedEvent?.userNom }} {{ selectedEvent?.userPrenom }}
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </div>

    </div>

</header>